<template>
  <v-dialog
    v-model="dialogChangePassword"
    @keydown.esc="changePasswordClose"
    persistent
    scrollable
    content-class="medium"
  >
    <v-card>
      <v-card-title>
        <span class="headline">Change password</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col class="text-center" cols="12" sm="12" md="12" lg="12">
              <v-avatar size="128">
                <img :src="user.avatar" alt="avatar" />
              </v-avatar>
            </v-col>
            <v-col class="text-center" cols="12" sm="12" md="12" lg="12">
              <span>{{ user.displayname }}</span>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12">
              <span>{{ user.email }}</span>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-text-field
                id="user-password-new-password"
                v-model="editChangePassword.oldPassword"
                :type="editChangePassword.showOldPassword ? 'text' : 'password'"
                label="Old password"
                :append-icon="
                  editChangePassword.showOldPassword ? 'mdi-eye' : 'mdi-eye-off'
                "
                hide-details
                @click:append="
                  editChangePassword.showOldPassword = !editChangePassword.showOldPassword
                "
                :disabled="tempOldPassword"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-text-field
                id="user-password-new-password-2"
                v-model="editChangePassword.newPassword"
                :type="editChangePassword.showNewPassword ? 'text' : 'password'"
                label="New password"
                :append-icon="
                  editChangePassword.showNewPassword ? 'mdi-eye' : 'mdi-eye-off'
                "
                hide-details
                @click:append="
                  editChangePassword.showNewPassword = !editChangePassword.showNewPassword
                "
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-text-field
                id="user-password-confirm-password"
                v-model="editChangePassword.confirmPassword"
                :type="
                  editChangePassword.showConfirmPassword ? 'text' : 'password'
                "
                label="Confirm password"
                :append-icon="
                  editChangePassword.showConfirmPassword
                    ? 'mdi-eye'
                    : 'mdi-eye-off'
                "
                hide-details
                @click:append="
                  editChangePassword.showConfirmPassword = !editChangePassword.showConfirmPassword
                "
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <div id="error-change-password" class="text-center red--text">
        {{ editChangePassword.errorMessage }}
      </div>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          id="btn-close-change-password"
          class="btn-secondary"
          text
          @click="changePasswordClose"
          >Cancel</v-btn
        >
        <v-btn
          id="btn-ok-change-password"
          class="btn-primary"
          text
          @click="changePasswordSave"
          >Change password</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import apiUser from '@/apis/user'
import { mapGetters } from 'vuex'

export default {
  name: 'DialogChangePassword',
  props: {
    dialogChangePassword: Boolean,
    tempOldPassword: String
  },
  computed: {
    ...mapGetters('auth', ['user'])
  },
  data() {
    return {
      editChangePassword: {
        oldPassword: '',
        showOldPassword: false,
        newPassword: '',
        showNewPassword: false,
        confirmPassword: '',
        showConfirmPassword: false,
        errorMessage: ''
      }
    }
  },
  created() {
    if (this.tempOldPassword)
      this.editChangePassword.oldPassword = this.tempOldPassword
  },
  methods: {
    changePasswordClose() {
      this.$emit('changePasswordClose', null)
    },
    async changePasswordSave() {
      //  this.$emit('changePasswordSave', null)
      try {
        if (!this.editChangePassword.oldPassword) {
          this.editChangePassword.errorMessage = 'Old password is required'
          return false
        } else if (!this.editChangePassword.newPassword) {
          this.editChangePassword.errorMessage = 'New password is required'
          return false
        } else if (!this.editChangePassword.confirmPassword) {
          this.editChangePassword.errorMessage = 'Confirm password is required'
          return false
        } else if (
          this.editChangePassword.newPassword !==
          this.editChangePassword.confirmPassword
        ) {
          this.editChangePassword.errorMessage =
            'Confirm password does not match'
          return false
        }
        const changePassword = await apiUser.changePassword(this.user._id, {
          old_password: this.editChangePassword.oldPassword,
          password: this.editChangePassword.newPassword
        })

        if (changePassword.code === 0) {
          this.$emit('changePasswordSave', null)
        } else {
          this.editChangePassword.errorMessage = changePassword.message
        }
      } catch (error) {
        this.editChangePassword.errorMessage = error.message
      }
    }
  }
}
</script>
